import { render, staticRenderFns } from "./UserPermissionsEditForm.vue?vue&type=template&id=039351e5&scoped=true&"
import script from "./UserPermissionsEditForm.vue?vue&type=script&lang=ts&"
export * from "./UserPermissionsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserPermissionsEditForm.vue?vue&type=style&index=0&id=039351e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039351e5",
  null
  
)

export default component.exports